import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const generateToken = createAction(ACTION.GENERATE_TOKEN.REQUEST);
export const clearState = createAction(ACTION.CLEAR_STATE);
